import React from 'react'
import styled from 'styled-components'
import ContentModal from '../../ContentModal'

import SwipeableViews from 'react-swipeable-views'
import { autoPlay, bindKeyboard } from 'react-swipeable-views-utils'
import IconFormArrowRight from '../../../vectors/IconFormArrowRight'
import media from '../../../utils/style'

const IconFormArrowLeft = styled(IconFormArrowRight)`
  transform: rotate(180deg);
`

const EnhancedSwipeableViews = autoPlay(bindKeyboard(SwipeableViews))

const ButtonNext = styled.div`
  z-index: 10;
  top: 60%;
  right: 0;
  width: 45px;
  height: 45px;
  background-color: rgba(0, 0, 0, 0.1);
  color: #fff;
  transform: translateY(-50%);
  cursor: pointer;
  margin-right: 12px;
  & svg {
    position: absolute;
    width: 15px;
    height: 15px;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    z-index: 10;
  }

  ${media.MediumScreenUp`
    height: 90px;
    width: 90px;
    svg {
      width: 25px;
      height: 25px;
    }
  `}
`

const ButtonPrevious = styled(ButtonNext)`
  left: 0;
`

import Card from './Card'

const Wrapper = styled.div`
  text-align: center;
  position: relative;
  color: ${(props) => props.theme.colors.white};
  padding: 40px 0 0;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 20%;
    left: 0;
    right: 0;
    background: ${(props) => props.theme.colors.careers_midblue};
  }

  h2 {
    font-size: 25px;
    margin-bottom: 40px;
    padding: 0 80px;
    color: ${(props) => props.theme.colors.white};

    @media (min-width: 960px) {
      font-size: 48px;
      padding: 0;
    }
  }

  .carousel {
    @media (min-width: 960px) {
      display: none;
    }
  }
  .carouselNavigation {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
`

const Inner = styled.div`
  max-width: 1360px;
  margin: 0 auto;
  position: relative;
  padding: 0 20px;
  z-index: 1;
`

const Grid = styled.div`
  display: none;
  @media (min-width: 960px) {
    display: flex;
    height: 850px;
    gap: 20px;
    flex-direction: row;
    > div {
      flex-grow: 1;
      gap: 20px;
      display: flex;
      flex-direction: column;
    }
  }
`

const VideoContainer = styled.div`
  padding: 20px;
`

class VideoGrid extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      modalOpen: false,
      videoId: '',
      index: 0
    }
    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleClickNext = this.handleClickNext.bind(this)
    this.handleClickPrevious = this.handleClickPrevious.bind(this)
    this.handleChangeIndex = this.handleChangeIndex.bind(this)
  }
  handleOpen(id) {
    this.setState({
      modalOpen: true,
      videoId: id
    })
  }

  handleClose() {
    this.setState({
      modalOpen: false,
      videoId: null
    })
  }

  handleClickNext(e) {
    e.preventDefault()
    this.setState({ index: this.state.index + 1 })
  }

  handleClickPrevious(e) {
    e.preventDefault()
    this.setState({ index: this.state.index - 1 })
  }

  handleChangeIndex(index) {
    this.setState({ index })
  }

  render() {
    const { index } = this.state
    const videoMap = {
      becky:
        'cd9606219fffc0c54ea5da3e4b9d8c53:3e9cac47ec8d8f6d497a255a26ddea32',
      dan: '6af367969226a19b5f0c725baa2501a1:512e30e27d6e64c5ea47ef250d6bc635',
      joshua:
        '85702ec0b8a56db35301a9a9db623241:86b52ca7e89d5426536f8e9d581b577a',
      craig:
        '99bb0919f0a740d6f25e43fdf2fc0f14:52e578af8cfc8f853a13364c9f2c5043',
      andrea:
        '4c53e7b70c0cac4b58aadbbcd39ba2be:87c269f845c61666cec99e3b4e7fb79a',
      sarah: '4495f7560a5e130bb725d5392ba22bcc:1015cc955938e203b356800d18a403a6'
    }
    const imageMap = {
      becky:
        'https://media.auto.works/original/159c84397bc72c9694e29c39e9481590:267e7ac4615bb764ef997d8f4545840a',
      dan:
        'https://media.auto.works/original/477b7bb3017c87e7362470647b4791b4:b5764e10c1c5b4bf445eab5cbee702f2',
      joshua:
        'https://media.auto.works/original/86fa4654f676affb8573a8a3fa576bce:35845d601646a9c823d61553affa3e87',
      craig:
        'https://media.auto.works/original/cbcc90ac5a8f90fb5271edcba73505ac:be28e49d3479bf0328e0fbd216aca554',
      andrea:
        'https://media.auto.works/original/8ebf069149dc045a2f56912350e85ec9:ad01ae8f6a16b5ccd7cb52f0f0342343',
      sarah:
        'https://media.auto.works/original/3624669a04b8b01042d6557c049cd395:142f587981cc5a89193b6a59865ba081'
    }
    const nextEnabled =
      this.state.index < Object.keys(imageMap || {}).length - 1
    const prevEnabled = this.state.index > 0

    return (
      <Wrapper>
        <Inner>
          <h2>What Our Team Has To Say...</h2>
          <div className="carousel">
            <div className="carouselNavigation">
              <ButtonPrevious
                onClick={
                  prevEnabled
                    ? this.handleClickPrevious
                    : () =>
                        this.setState({
                          index: Object.keys(imageMap || {}).length - 1
                        })
                }
              >
                <IconFormArrowLeft />
              </ButtonPrevious>
              <ButtonNext
                onClick={
                  nextEnabled
                    ? this.handleClickNext
                    : () => {
                        this.setState({ index: 0 })
                      }
                }
              >
                <IconFormArrowRight />
              </ButtonNext>
            </div>
            <EnhancedSwipeableViews
              enableMouseEvents={true}
              autoplay={false}
              interval={4000}
              index={index}
              disableLazyLoading={true}
              onChangeIndex={this.handleChangeIndex}
            >
              <Card
                handleOpen={() => this.handleOpen('becky')}
                image={imageMap['becky']}
                title="Becky's story"
                subtitle="Bodyshop Apprentice Technician"
              />
              <Card
                handleOpen={() => this.handleOpen('dan')}
                title="Dan's story"
                image={imageMap['dan']}
                subtitle="Senior Service Advisor"
              />
              <Card
                handleOpen={() => this.handleOpen('joshua')}
                title="Joshua's story"
                image={imageMap['joshua']}
                subtitle="Service Technician"
              />
              <Card
                handleOpen={() => this.handleOpen('craig')}
                title="Craig's story"
                image={imageMap['craig']}
                subtitle="Master Technician"
              />
              <Card
                handleOpen={() => this.handleOpen('andrea')}
                title="Andrea's story"
                image={imageMap['andrea']}
                subtitle="Sales Executive Trainee"
              />
              <Card
                handleOpen={() => this.handleOpen('sarah')}
                title="Sarah's story"
                image={imageMap['sarah']}
                subtitle="Sales Executive"
              />
            </EnhancedSwipeableViews>
          </div>
          <Grid>
            <div>
              <Card
                handleOpen={() => this.handleOpen('becky')}
                image={imageMap['becky']}
                title="Becky's story"
                subtitle="Bodyshop Apprentice Technician"
              />
              <Card
                handleOpen={() => this.handleOpen('craig')}
                image={imageMap['craig']}
                title="Craig's story"
                subtitle="Master Technician"
              />
            </div>
            <div>
              <Card
                handleOpen={() => this.handleOpen('dan')}
                title="Dan's story"
                image={imageMap['dan']}
                subtitle="Senior Service Advisor"
              />
              <Card
                handleOpen={() => this.handleOpen('andrea')}
                title="Andrea's story"
                image={imageMap['andrea']}
                subtitle="Sales Executive Trainee"
              />
            </div>
            <div>
              <Card
                handleOpen={() => this.handleOpen('joshua')}
                title="Joshua's story"
                image={imageMap['joshua']}
                subtitle="Service Technician"
              />
              <Card
                handleOpen={() => this.handleOpen('sarah')}
                image={imageMap['sarah']}
                title="Sarah's story"
                subtitle="Sales Executive"
              />
            </div>
          </Grid>
        </Inner>
        {this.state.videoId && (
          <ContentModal
            slim
            onClose={this.handleClose}
            open={this.state.modalOpen}
          >
            <VideoContainer>
              <video width="100%" height="100%" autoPlay controls>
                <source
                  src={`https://media.auto.works/original/${
                    videoMap[this.state.videoId]
                  }`}
                  type="video/mp4"
                />
              </video>
            </VideoContainer>
          </ContentModal>
        )}
      </Wrapper>
    )
  }
}

export default VideoGrid
